import { createSlice } from '@reduxjs/toolkit';
import {
  getAllDrivers,
  getDetailDriver,
  getDriverTransactionHistory,
  getAllDriversByFilter,
  getDetailVehiclePackages,
  uploadImageVehicle,
  getVehiclePackages,
  getAllNewRegisteredDrivers,
  getDriverReviews,
  getDriverRating,
} from './actions';

const initialState = {
  data: {},
  selected: {},
  history: {},
  vehiclePackages: [],
  detailVehiclePackage: {},
  reviews: {},
  rating: {},
  reviewsLoading: false,
  ratingLoading: false,
  reviewsError: null,
  ratingError: null,
  page: 1,
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const drivers = createSlice({
  name: 'drivers',
  initialState,
  reducers: {
    // reducers goes here
    resetSelectedDriver: (state) => {
      state.selected = {};
    },

    deleteImageVehicle: (state, action) => {
      if (state.selected?.vehicle) {
        state.selected.vehicle.photo = action.payload;
      }
    },

    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllDrivers.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = {};
      })
      .addCase(getAllDrivers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getAllDrivers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getDetailDriver.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.selected = {};
      })
      .addCase(getDetailDriver.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getDetailDriver.fulfilled, (state, action) => {
        state.isLoading = false;
        state.selected = action.payload;
      })
      .addCase(getDriverTransactionHistory.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.history = {};
      })
      .addCase(getDriverTransactionHistory.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getDriverTransactionHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.history = action.payload;
      })
      .addCase(getAllDriversByFilter.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = {};
      })
      .addCase(getAllDriversByFilter.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getAllDriversByFilter.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getVehiclePackages.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
      })
      .addCase(getVehiclePackages.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getVehiclePackages.fulfilled, (state, action) => {
        state.isLoading = false;
        state.vehiclePackages = action.payload.data;
      })
      .addCase(getDetailVehiclePackages.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
      })
      .addCase(getDetailVehiclePackages.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getDetailVehiclePackages.fulfilled, (state, action) => {
        state.isLoading = false;
        state.detailVehiclePackage = action.payload;
      })
      .addCase(uploadImageVehicle.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
      })
      .addCase(uploadImageVehicle.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(uploadImageVehicle.fulfilled, (state, action) => {
        state.isLoading = false;

        if (Object.keys(state.selected).length === 0) {
          state.selected = { vehicle: { photo: [action.payload] } };
        } else {
          const oldPhotos = state.selected?.vehicle?.photo ? [...state.selected.vehicle.photo] : [];
          state.selected.vehicle.photo = [...oldPhotos, action.payload];
        }
      })
      .addCase(getAllNewRegisteredDrivers.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = {};
      })
      .addCase(getAllNewRegisteredDrivers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getAllNewRegisteredDrivers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getDriverReviews.pending, (state) => {
        state.reviewsLoading = true;
        state.reviewsError = null;
        state.reviews = {};
      })
      .addCase(getDriverReviews.rejected, (state, action) => {
        state.reviewsLoading = false;
        state.reviewsError = action.payload;
      })
      .addCase(getDriverReviews.fulfilled, (state, action) => {
        state.reviewsLoading = false;
        state.reviews = action.payload;
      })
      .addCase(getDriverRating.pending, (state) => {
        state.ratingLoading = true;
        state.ratingError = null;
        state.rating = {};
      })
      .addCase(getDriverRating.rejected, (state, action) => {
        state.ratingLoading = false;
        state.ratingError = action.payload;
      })
      .addCase(getDriverRating.fulfilled, (state, action) => {
        state.ratingLoading = false;
        state.rating = action.payload;
      });
  },
});

export const { resetSelectedDriver, deleteImageVehicle, setPage } = drivers.actions;

export default drivers.reducer;
